export const ports = [
  "Aabenraa",
  "Aalborg",
  "Aalesund",
  "Aarhus",
  "Aarø",
  "Aberdeen",
  "Abidjan",
  "ABIDJAN",
  "Abo",
  "Åbo (Turku)",
  "Abu Dhabi",
  "Abu Field",
  "Acajutla",
  "Acapulco",
  "Acu",
  "Acu Port - T1 - Offshore Terminal",
  "Adelaide",
  "Adelaide, Birkenhead",
  "Adelaide, SA",
  "Aden",
  "Admiralty Bay",
  "Afrika haven",
  "Agadir",
  "Agbami Terminal",
  "Agio Theodoroi",
  "Ailsa FSO",
  "Aioi",
  "Ajaccio",
  "Akita",
  "Akou",
  "Akrotiri",
  "Al Adabiyah",
  "Al Fujairah",
  "Al Fujayrah",
  "Al Shaheen",
  "Aladja",
  "Albany",
  "Albertkanaal",
  "Albuera",
  "Ålesund",
  "Algeciras",
  "Alger (Algiers)",
  "Aliaga",
  "Alicante",
  "Alotau",
  "Al-Shaheen",
  "Alta",
  "Altamira",
  "Ambarli",
  "Ambarli Depolama Hizmetleri Ltd. Sti.",
  "Ambon",
  "Amchit",
  "Amsterdam",
  "Amuay",
  "Amurang",
  "Anacortes",
  "Anacortes, WA",
  "Anan",
  "ANCAP",
  "Anchorage",
  "Andenes",
  "Andernach",
  "Andros Town, Andros Island",
  "Ango Ango",
  "Angra dos Reis",
  "Angsi",
  "Anibong",
  "Annaba (ex Bone)",
  "ANP - Nueva Palmira",
  "Anta",
  "Antalya",
  "Antan",
  "Antofagasta",
  "Antsiranana",
  "Antwerp",
  "Antwerpen",
  "Anyer Kidul",
  "Aomori",
  "Aqaba",
  "Ar Ruways",
  "Aracaju - SE",
  "Aracuz - ES",
  "Aransas Pass",
  "Aratu",
  "Ardjuna",
  "Arendal",
  "Arica",
  "Arnsberg",
  "Arzew",
  "As Sidr",
  "Asaluyeh",
  "Ascension Island",
  "Aschaffenburg",
  "Asgaard",
  "Ashburton",
  "ASHDOD",
  "Ashkelon",
  "Ashtart Terminal",
  "Asprópirgos",
  "Atapupu",
  "ATAS OIL TERMINAL",
  "Atherinolakos",
  "ATLANTIC LNG TERMINAL",
  "Atsumi",
  "Auckland",
  "Augusta",
  "Avatiu",
  "Aveiro",
  "Avonmouth",
  "Az Zawiyah",
  "Azov",
  "Ba Ria Vung Tau Port",
  "Bacolod",
  "Bacon",
  "Badas",
  "Bahía Blanca",
  "Bahrain LNG Port",
  "Bais",
  "Bajo Grande/Maracaibo L",
  "Baku",
  "Balboa",
  "Balhaf",
  "Balikpapan",
  "Balingasag",
  "Ballstad",
  "Balongan Terminal",
  "Baltimore",
  "Baltimore, Maryland",
  "Baltiysk",
  "Bandar Lampung",
  "Bandar-e Måh Shahr",
  "Bandon",
  "Bangar",
  "Bangkok",
  "Bangor",
  "Baniyas",
  "Banjarmasin",
  "Banjul",
  "Banjuwangi",
  "Bantry",
  "Bantry Bay",
  "Barber Point, Oahu, Hawaii",
  "Barbers Point (Oahu)",
  "Barcadera",
  "Barcelona",
  "Barletta",
  "Barquito",
  "Barra dos Coqueiros",
  "Barranqueras",
  "Barranquilla",
  "Barrow in Furness",
  "BARROW ISLAND",
  "Barry Dock",
  "Basamuk",
  "Basel",
  "Basrah Port",
  "Basseterre",
  "Bastia",
  "BATA PUERTO",
  "Bataan",
  "Batam",
  "Batangas",
  "Batangas/Luzon",
  "Baton Rouge",
  "Båtsfjord",
  "Batu Ampar",
  "Batumi",
  "Bau-Bau",
  "Bay City MI",
  "Bayonne",
  "Bayovar",
  "Baytown",
  "Bayu Undan",
  "BAYUQUAN",
  "Beaumont",
  "BEIHAI",
  "Beinheim",
  "Beira",
  "BEIRUT",
  "Bejaia (ex Bougie)",
  "Belanak Offshore",
  "Belawan",
  "Belem",
  "Belem - PA",
  "Belfast",
  "Belida Offshore",
  "Belize City",
  "Bell Bay",
  "Bellingham, WA",
  "Belpre",
  "Benchamas",
  "Bengkulu",
  "Benicia",
  "Bergen",
  "Berlin",
  "Beverwijk",
  "Bialla",
  "Big Stone, DE",
  "Bilbao",
  "BILBAO PORT",
  "Binh Thuan Oilfield",
  "Bintulu",
  "Bintulu Port",
  "Birkenhead",
  "Bitung",
  "Bizerte",
  "Bjerkvik",
  "Blang Lancang",
  "Blaye",
  "Blyth",
  "Boac, Marinduque",
  "Boca Chica",
  "Bodø",
  "Bohai BZ 34",
  "Bonga",
  "Bonn",
  "Bonny",
  "Bonny Oil and Gas Terminal",
  "Bontang",
  "Bordeaux",
  "Borgå (Porvoo)",
  "Boryeong Port",
  "Boston",
  "Botany",
  "Botany Bay",
  "Botingé",
  "Bottrop",
  "Bouri Field Terminal",
  "BP Kirra St",
  "BP Supsa Marine Terminal",
  "Braefoot Bay",
  "Braithwaite",
  "Brake",
  "Brass",
  "Bratislava",
  "Braunschweig",
  "Breisach",
  "Bremen",
  "Breskens",
  "Brest",
  "Bridgeport",
  "Bridgetown",
  "Brindisi",
  "Brisbane",
  "Brisbane- Caltex- Lytton",
  "Bristol",
  "Brofjorden",
  "Broome",
  "Brownsville",
  "Brunsbüttel",
  "Brunswick",
  "Buatan",
  "Buckeye St Lucia Terminal Ltd",
  "Bucksport",
  "Buenaventura",
  "Buenos Aires",
  "Bukit Tua Offshore",
  "Bullay",
  "Bullen Bay",
  "Bunbury",
  "BunkerOil",
  "Burgas",
  "Burnie",
  "Busan",
  "Busan (YongDang)",
  "Cabadbaran",
  "Cabedelo",
  "Cabinda",
  "Cabo Negro",
  "Cadiz",
  "Cagayan de Oro",
  "Cagayan de Sulu",
  "Cai Lan",
  "CAI MEP",
  "Cairns",
  "Calabar",
  "Calapan",
  "Calbuco",
  "Caldera",
  "Callao",
  "Campana",
  "Campbeltown",
  "Can Tho",
  "Caniçal",
  "Caofeidian Pt",
  "Cape Town",
  "Cardiff",
  "Carriacou",
  "Cartagena",
  "Casablanca",
  "Castellón",
  "Catania",
  "Catia La Mar",
  "Catlettsburg",
  "Cayo Arcas Terminal",
  "Cebu",
  "Cekisan Storage Facilities - Antalya CBM",
  "Çekisan Storage Facilities Ltd. Co. - Çekmece Terminal",
  "Celukan Bawang",
  "Cendor",
  "Center Point Terminal Company Port Allen Terminal",
  "Ceuta",
  "CEYHAN",
  "Chagrin Falls",
  "CHAGUARAMAS",
  "Chalampe",
  "Chalna",
  "CHAN MAY PORT/ THUA THIEN HUE",
  "Chandra Asri",
  "CHANGSHU",
  "Changzhou Pt",
  "Charenton, LA",
  "Charleston",
  "Charlestown",
  "Charlotte (Skidegate)",
  "Chattanooga, TN",
  "Chattogram",
  "Chekka",
  "Chemainus BC, Canada",
  "Chennai (ex Madras)",
  "Cherry Point Marine Terminal",
  "Chesapeake",
  "Chiba",
  "Chicago",
  "Chimbote",
  "Chios",
  "Chiriquí Grande",
  "Chittagong",
  "Chocolate Bayou",
  "CHORNOMORSK (ILLICHEVSK)",
  "Cidade de Angra dos Reis",
  "Cidade de Ilhabela",
  "Cidade de Mangaratiba",
  "Cidade de Marica",
  "Cidade de Paraty",
  "Cidade de Sao Paulo",
  "Cidade de Saquarema",
  "Cidade Itaguai FPSO",
  "Cilacap",
  "Cincinnati",
  "Cinta offshore",
  "Cirebon (Tjeribon)",
  "Ciudad Madero",
  "Civitavecchia",
  "Ciwandan",
  "Cleveland",
  "Coari - AM",
  "Coatzacoalcos",
  "Cochin",
  "Coco Solo",
  "Cocos Island",
  "Colombo",
  "Colon",
  "Come By Chance",
  "Comodoro Rivadavia",
  "Compania Terminal de Tuxpan",
  "Conakry",
  "Constanta",
  "Convent",
  "Coquimbo",
  "Corinto",
  "Cork",
  "Corner Brook",
  "Coronel",
  "Corpus Chrisit",
  "Corpus Christi",
  "Cotonou",
  "Cove Point",
  "Coveñas",
  "Cowes",
  "Cristóbal",
  "Cromarty Firth",
  "CSPC DongLian terminal (Hui Zhou)",
  "CSPC Ma bian Zhou Terninal (Hui Zhou)",
  "Cua Viet",
  "Culao",
  "Curlew",
  "Da Nang",
  "Daesan",
  "Dahej",
  "Dai Hung",
  "Dakar",
  "Dakhla",
  "Dalhousie",
  "Dalian",
  "Dammam",
  "Dampier",
  "Dar es Salaam",
  "Darwin",
  "Das Island",
  "Davao",
  "Decatur",
  "Degrad des Cannes",
  "De-Kastri",
  "Delaware",
  "Delfzijl",
  "Den Helder",
  "Derince",
  "Derna",
  "Detroit",
  "Devonport",
  "Dhekelia",
  "Didon",
  "Diego Garcia",
  "Dighi",
  "Djen-Djen",
  "Djeno",
  "Doha",
  "Dong Nai",
  "Donges",
  "Dongguan Port",
  "Dongjiakou",
  "Dongying",
  "Donsö",
  "DORALEH BULK PORT",
  "Dordrecht",
  "Dormagen",
  "Dorozhnoye",
  "Dortmund",
  "Dörtyol",
  "Dos Bocas Terminal",
  "DOUALA",
  "Douglas",
  "Dragor",
  "Drift River",
  "Dubai",
  "Dublin",
  "Duesseldorf",
  "Duisburg",
  "Dumai",
  "Dumyat (Damietta)",
  "Dunafoldvar",
  "Dundee",
  "DUNG QUAT PETROLEUM PORT",
  "Dunkerque",
  "Dunkirk",
  "Durban",
  "Durban Harbour",
  "Durban SBM",
  "Durres",
  "Dutch Harbor, AK",
  "DZAOUDZI",
  "East London",
  "Ebok Field",
  "Eemshaven",
  "Egersund",
  "Ehoala",
  "El DEKHEILA PORT",
  "El Iskandariya (Alexandria)",
  "El Musel (Gijon)",
  "El Palito",
  "El Segundo",
  "Eleusina",
  "Emden",
  "Engis",
  "Ennore",
  "Erawan",
  "Eregli",
  "Erha",
  "Esbjerg",
  "Escravos",
  "Esmeraldas",
  "Esperance",
  "Espirito Santo",
  "Essen",
  "Etajima",
  "Etame",
  "Eten",
  "Eureka Chevron Terminal",
  "Europoort",
  "Everett, WA",
  "EXXON MOBIL SINGAPORE",
  "Ezhou",
  "Falconara",
  "Fall River",
  "Falmouth",
  "Fangcheng Pt",
  "Fateh Terminal",
  "Fawley",
  "Féluy",
  "Feodosiya",
  "Ferndale",
  "Ferrol",
  "Ferryden, Montrose",
  "Finnart Ocean Terminal",
  "Fiumicino",
  "Flora",
  "Florø",
  "Flotta",
  "Fluminense",
  "FLUSHING",
  "Folsom",
  "Førde",
  "Fort Bragg",
  "Fort Lauderdale",
  "Fortaleza",
  "Fortaleza - CE",
  "Fort-de-France",
  "Fos",
  "Foshan",
  "Fos-sur-Mer",
  "Foynes",
  "FPSO AKPO",
  "FPSO GIRASSOL",
  "FPSO Global Producer III",
  "FPSO Gryphon A",
  "Frade - Campos Basin",
  "Frankfurt",
  "Fray Bentos",
  "Frederikshavn",
  "Fredrikshamn (Hamina)",
  "Fredrikstad",
  "Freeport",
  "Freeport (US Texas)",
  "Freeport Harbour",
  "Freeport, Bermuda",
  "FREEPORT,FL",
  "Freetown",
  "Fremantle",
  "FSO UNITY",
  "FSO-LPG NKOSSA 2",
  "FSU-STS Batam Anchorage",
  "Fujairah",
  "Fukui",
  "Funafuti",
  "Futila",
  "Fuzhou Port",
  "GABES",
  "Gaeta",
  "Gale",
  "Galela",
  "Galveston",
  "Galway",
  "Gamagori",
  "Gangavaram",
  "Garongkong Port",
  "Garyville, LA",
  "GAS-PVC PHUOC THAI",
  "Gävle",
  "Gdansk",
  "Gdynia",
  "Gebze",
  "Geel",
  "Geelong",
  "GELA",
  "Gelsenkirchen Horst",
  "Gemlik Terminal",
  "General Santos",
  "Genova",
  "Gent (Ghent)",
  "Geoje",
  "Georgetown",
  "Gernsheim",
  "Gesimar",
  "Ghazaouet",
  "Ghent",
  "Gibbstown, LA",
  "Gibraltar",
  "Gibson, LA",
  "GIJON",
  "Gijón",
  "Gimboa",
  "Gina Krog",
  "Gladstone",
  "Gladstone, Queensland, Australia",
  "Glasgow",
  "Glen Dale, WV",
  "Glenmont",
  "Global Marine S.A",
  "Glomfjord",
  "Godby",
  "Gorontalo",
  "Göteborg",
  "Gouvia Marina",
  "GPMR - Grand Port Maritime ROUEN",
  "Grand Bourg",
  "Grand Port Maritime de Nantes - Saint Nazaire",
  "Grand Port Maritime du Havre",
  "Grangemouth",
  "Grays Harbor City, WA",
  "Great Yarmouth",
  "Greater Plutonio",
  "Green Bay, WI",
  "Greenock",
  "Greenville, MS",
  "Gresik",
  "Groningen",
  "Groton",
  "GT Omniport",
  "Guam",
  "Guamare - RN",
  "Guangzhou Port",
  "Guayacán",
  "Guayanilla",
  "Guayaquil",
  "Guaymas",
  "Gulfhavn",
  "Gunsan",
  "Guntersville, AL",
  "Gustavia",
  "HA TINH",
  "Hachinohe",
  "Hadera",
  "HAI PHONG",
  "HAI YANG SHI YOU 102",
  "HAI YANG SHI YOU 112",
  "HAI YANG SHI YOU 115",
  "Haifa",
  "Haikou",
  "Haiphong",
  "Hakodate",
  "Halalo",
  "Haldia",
  "Halifax",
  "Hallstavik",
  "Halmstad",
  "Halul",
  "Hamada",
  "Hambantota",
  "Hamburg",
  "Hamburg Norderelbe",
  "Hamilton",
  "Hamina (Fredrikshamn)",
  "Hamm",
  "Hammerfest",
  "Hamnina",
  "Hamriyah",
  "Hanau",
  "Hannover",
  "Harbour Holthausen",
  "Harbour of Pascagoula",
  "Harstad",
  "Hartford",
  "Hartford Ilinois",
  "Hartford, Illinois",
  "Harwich",
  "Hastings",
  "Haugesund",
  "Havoysundet",
  "Hazira (Surat) Port",
  "Hazira Port/Surat",
  "Hedland",
  "Heidrun",
  "Helguvik",
  "Hellerup",
  "Helsingborg",
  "Helsingfors (Helsinki)",
  "Hennepin, IL",
  "Henningsvar",
  "Heraklion (Iraklion)",
  "Heroy",
  "Hiep Phuoc Port",
  "Hilo",
  "Himeji",
  "Hiroshima",
  "Hirtshals",
  "Hitachi",
  "HO CHI MINH",
  "Ho Chi Minh City",
  "HO CHI MINH PORT",
  "Hobart",
  "Hobro",
  "Holyrood",
  "Homer, AK",
  "Hong Kong",
  "Hongai",
  "Honiara",
  "Honolulu",
  "Hooksett",
  "Hopewell, VA",
  "Horseshoe",
  "Hosvik",
  "Houma, LA",
  "Hound Point",
  "Houston",
  "Houston, Texas",
  "Houston, TX",
  "HUANGPU",
  "Huangpu Pt",
  "Huelva",
  "HUIZHOU",
  "Huizhou Pt",
  "Hulaylah",
  "Humen Pt",
  "Husum",
  "Ichthys Field",
  "Ichthys ILNG",
  "Idku LNG Port",
  "Ijmuiden",
  "Ilheus",
  "Iligan",
  "Ilo",
  "Iloilo",
  "Ima",
  "Imabari",
  "IMMINGHAM",
  "Incheon",
  "INEOS Stenungsund",
  "Inkoo (Ingå)",
  "Inland River Terminal",
  "Inverness",
  "Iquique",
  "Ishikari",
  "Iskenderun",
  "Isle of Grain",
  "Istanbul",
  "Itacoatiara",
  "Itaituba",
  "Itaqui",
  "Itaqui - MA",
  "Iwakuni",
  "IZMIT",
  "Jabung Offshore",
  "Jacksonville",
  "Jakarta",
  "Jambi",
  "Jawaharal Nehru Port",
  "Jayapura",
  "JD RUWAIS",
  "Jebel Ali",
  "Jebel Ali Port",
  "Jebel ali port Dubai",
  "Jeddah",
  "Jeju",
  "Jennings",
  "Jetty 4",
  "Jia Xing Port",
  "Jiangmen Pt",
  "Jiangyin Pt",
  "Jieyang",
  "Jimenez/Ozamis",
  "Jinzhou Pt",
  "Jizan",
  "Johor Port Berhad",
  "Joliet",
  "Jonesville",
  "Jorf Lasfar",
  "Jose Ignacio Terminal",
  "Jose Terminal",
  "Jounieh / Zouk",
  "Juaymah Terminal",
  "Jubail",
  "Jubilee",
  "Jurong Island Singapore",
  "JURONG PORT UNIVERSAL TERMINAL",
  "Kagoshima",
  "Kahului Harbor",
  "Kakap Natuna Offshore",
  "Kakinada",
  "Kakogawa",
  "Kalamata Anchorage",
  "Kalecik",
  "Kaliningrad",
  "Kalmar",
  "Kalundborg",
  "Kalymnos",
  "Kamaishi",
  "Kâmpóng Saôm",
  "Kampung Tanjung Langsat",
  "Kamsar",
  "Kanazawa",
  "KANDALAKSHA",
  "Kandla",
  "Kanmon",
  "Kaohsiung",
  "KAOMBO NORTE",
  "KAOMBO SUL",
  "Karachi",
  "Karaikal",
  "Karatsu",
  "Karimun",
  "Kariya",
  "Karlshamn",
  "Karlskrona",
  "Karlsruhe",
  "Karlstad",
  "KARMSUND SERVICEBASE AS",
  "Kårstø",
  "Karwar",
  "Kashima",
  "Kashiwazaki",
  "Kasim",
  "Kavala",
  "Kavkaz",
  "Kawasaki",
  "Keelung (Chilung)",
  "Kehl",
  "Kelsterbach",
  "KEMAMAN, MALAYSIA",
  "Kemi/Tornio (Kemi/Torne)",
  "Kenai/Nikiski Alaska",
  "Kendari",
  "Kerawang",
  "Kertih",
  "Kertih Port",
  "Kesenmuma",
  "Khalifa Bin Salman",
  "Kharg Island",
  "Kholmsk",
  "Khor al Zubair",
  "Khulna",
  "Kiel",
  "Kiire",
  "Kikuma",
  "Kimbe",
  "King Fahad Industrial Port",
  "King Fahd Industrial Port Yanbu",
  "Kingston",
  "Kingstown",
  "Kinuura",
  "Kirkenes",
  "Kisarazu",
  "Kitimat",
  "Klaipeda",
  "Klaipeda Seaport",
  "Klaksvik",
  "Kobe",
  "København",
  "Kochi",
  "Køge",
  "Koh Sichang",
  "Kokkola (Karleby)",
  "KOKO",
  "Kolding",
  "Kole Terminal",
  "Kolkata (ex Calcutta)",
  "Köln",
  "Komarom",
  "Koper",
  "Korsakov",
  "Korsør",
  "Kota Kinabalu",
  "Kotka",
  "Kotzebue, AK",
  "Krabi",
  "Kralendijk",
  "KRISHNAPATNAM",
  "Kristiansand",
  "Kristiansund",
  "Krotz Springs, LA",
  "KUALA BELAIT",
  "Kuala Tanjung",
  "Kuantan (Tanjong Gelang)",
  "Kuito",
  "Kulevi",
  "Kumai",
  "Kumira, Chittagong",
  "Kumul",
  "Kunak",
  "Kunda",
  "Kupang",
  "Kure",
  "Kushiro",
  "Kuwait",
  "Kwinana, Fremantle",
  "Kyaukphu",
  "La Brea (Brighton)",
  "LA CORUÑA",
  "La Goulette Nord (Halqueloued)",
  "La Libertad, SUINLI",
  "La Paz",
  "La Plata",
  "La Rochelle",
  "La Romana",
  "La Skhirra",
  "La Spezia",
  "Laayoune",
  "Laayoune (El Aaiun)",
  "Labuan",
  "Labuan Port",
  "Lagos",
  "Lahad Datu",
  "Lake Charles",
  "Lake Charles, LA",
  "Lalang Terminal",
  "LAMINARIA FIELD",
  "Lamongan",
  "Langsa Oilfield",
  "Lanshan Pt",
  "Lanzarote",
  "Larnaca",
  "Larose, LA",
  "Larvik",
  "Las Palmas de Gran Canaria",
  "Lautoka",
  "Lavan",
  "Lavera",
  "Lavrion (Laurium)",
  "Lazaro Cardenas",
  "Le Havre",
  "Le Trait",
  "Leer",
  "Leixões",
  "Lemont, IL",
  "Lemvig",
  "Lerma",
  "Lewisporte",
  "Lianyungang",
  "Libreville",
  "LIEN CHIEU OIL STORAGE STORAGE TERMINAL",
  "Liepaja",
  "Limassol",
  "Limbe",
  "Limboh Terminal",
  "Limetree Bay",
  "Lion FPSO",
  "Lisboa",
  "Little Rock",
  "Liverpool",
  "Liverpool Bay Terminal",
  "Livorno",
  "Livorno (Italy) (offshore)",
  "Loch Striven",
  "Lockport, LA",
  "Lodingen",
  "Lome",
  "London",
  "Londonderry",
  "Long Beach",
  "Long Beach California",
  "Long Beach, CA.",
  "Long Beach, California",
  "LONGKOU",
  "LONGONI",
  "Lorient",
  "Los Angeles",
  "Louisiana Offshore Oil Port (LOOP LLC)",
  "Louisville",
  "Luanda",
  "Luderitz",
  "Ludwigshafen",
  "Luelsdorf",
  "Luleå",
  "Lumut",
  "Luwuk",
  "Luxembourg",
  "Macau",
  "Maceió",
  "Mackay",
  "Madang",
  "Madeira",
  "Madura Offshore",
  "Magdalla",
  "Magdeburg",
  "Mahajanga",
  "Mai-liao",
  "Maintirano",
  "Mainz",
  "Maizura",
  "Majuro",
  "Makarovo",
  "Makassar",
  "Makhachkala",
  "MALABO PORT",
  "Malacca",
  "MALAGA PORT",
  "Malahayati Aceh",
  "Malakal Harbour",
  "Male",
  "Malili",
  "Malmö",
  "Malongo",
  "Måløy",
  "Manaus",
  "Manaus - AM",
  "Manchester",
  "Mandal",
  "Mangalia",
  "Mangalore",
  "Manila",
  "Mannheim",
  "Manta",
  "Manzanillo",
  "Maoming",
  "Map Ta Phut",
  "Map Ta Phut SPM",
  "Map Ta Phut, Thailand",
  "MAPTAPHUT PORT",
  "Maputo",
  "Maracaibo",
  "Marcus Hook",
  "Marcus Hook, PA",
  "Marietta, OH",
  "Marine Port Primorsk",
  "Marmara Ereglisi",
  "Marmugao (Marmagao)",
  "Maroantsetra",
  "Marsa Brega",
  "Marsa el Hariga",
  "Marsaxlokk",
  "Marsden Point",
  "Marseille",
  "Marstal",
  "Martinez",
  "Martinez, CA",
  "Masbate",
  "Massawa (Mitsiwa)",
  "Matanzas",
  "Matarani",
  "Matsuyama",
  "Maumere",
  "Mayaguez",
  "Mazatlan",
  "Mégara",
  "Mejillones",
  "Melbourne",
  "Melbu",
  "Melchorita",
  "Melones Oil Terminal",
  "Melville Island",
  "Memphis",
  "Merak",
  "Mermentau",
  "Mersa El Hamra",
  "Mersin",
  "Mesaieed",
  "Miami",
  "Midia",
  "Miðsandur",
  "Miike",
  "Mikawa",
  "Milazzo",
  "Milford Haven",
  "Mina' al Ahmadi",
  "Mina Al Fahal",
  "Mina Al Hamadi",
  "Mina Al-Zour",
  "Mina Khalifa",
  "Mina Saqr",
  "Mina Saud",
  "Mindelo",
  "Miri",
  "Miri, Sarawak",
  "MIS TEST Wallwin Port 1",
  "MIS TEST Wallwin Port 2",
  "Mishimakakawanoe",
  "Misool Offshore",
  "Misurata",
  "Mizushima",
  "Mo i Rana",
  "Mobile",
  "Moerdijk",
  "Mohammedia",
  "Moji",
  "Mollendo",
  "Mombasa",
  "Monaca, PA",
  "Mongla",
  "Mongstad",
  "Monroe",
  "Monrovia",
  "Montara Field",
  "Montego Bay",
  "Montevideo",
  "Montoir",
  "Montoir-de-Bretagne",
  "Montreal",
  "Morgan City",
  "Mormugao Port",
  "Mosjøen",
  "Moskalvo",
  "Moss",
  "Mossel Bay",
  "Mostaganem",
  "Motiva Port Neches",
  "Motril",
  "Moudi Terminal",
  "Mount Vernon, IN",
  "Mt. Airy",
  "Mtwara",
  "Muanda",
  "Muara",
  "Muara Port",
  "Mubarek Offshore",
  "Mubarraz Island",
  "Muenster",
  "Muhammad Bin Qasim/Karachi",
  "Mul Dwårka",
  "Mulhouse",
  "Mumbai (ex Bombay)",
  "Mundra",
  "Munguba",
  "Murmansk",
  "Muroran",
  "Muuga",
  "N/A",
  "Nacala",
  "Nådendal (Naantali)",
  "Nador",
  "Nagahama",
  "Nagasaki",
  "Nagoya",
  "Naha",
  "Nakagusuku",
  "Nakhodka",
  "Nakskov",
  "Namikata",
  "Namsos",
  "NAN HAI SHENG KAI",
  "NAN HAI SHENG LI",
  "Nanaimo",
  "Nanao",
  "Nanbian",
  "NANHAI FAXIAN",
  "Nanjing",
  "NANJING 32",
  "Nanjing port , Jiangsu provice , China",
  "Nanjing, China",
  "Nantes",
  "Nantong Pt",
  "Naoetsu",
  "Naoshima",
  "Napoli",
  "Narvik",
  "Nasipit/Masao",
  "Nassau",
  "Natchez, MS",
  "Navigator",
  "Nawiliwili",
  "Neches River",
  "Necochea",
  "Nemrut - Aliaga",
  "Nemrut Bay",
  "Neuss",
  "New Haven",
  "New Haven, CT",
  "New Iberia, LA",
  "New Madrid, MO",
  "New Mangalore Port",
  "New Orleans",
  "New Orleans, LA",
  "New York",
  "Newburgh",
  "Newcastle",
  "Newport",
  "Nexø",
  "Nganhurra",
  "Nghe An",
  "Nha Be Oil Port",
  "Nhava Sheva (Jawaharlal Nehru)",
  "Nibe",
  "Niceville",
  "Nigg",
  "Nigtevecht",
  "Niigatahigashi",
  "Niihama",
  "Nikiski, Alaska",
  "NIKOLAYEV",
  "Ningbo",
  "Ningbo Lishe International Airport",
  "Njord",
  "NLNG Bonny Terminal",
  "Norco",
  "Nordby",
  "Norfolk",
  "Noro",
  "Norrköping",
  "Norte Capixaba - ES",
  "Nosy Be",
  "Nosy-Be",
  "Nouadhibou",
  "Nouakchott",
  "Nouméa",
  "Novorossiysk",
  "NPC Port, Map Ta Phut, Rayong",
  "NuStar Virginia Beach",
  "Nyborg",
  "Nykøbing Falster",
  "Nynäshamn",
  "Odense",
  "Odesa",
  "Oevel",
  "OFFSHORE - BLOCK 17",
  "OFFSHORE ANGOLA - BLOCK 17",
  "OFFSHORE NIGERIA-OML 130",
  "Oguendjo Offshore",
  "Ohigawa",
  "Oita",
  "Okarem",
  "Okha",
  "Okono Offshore",
  "Omaezaki",
  "Omisalj",
  "Omisalj, Croatia",
  "Onahama",
  "Onne",
  "Oostende (Ostend)",
  "Oran",
  "Orange",
  "Oristano",
  "Ornskoldsvik",
  "Orobay",
  "Ortona",
  "Osaka",
  "Oskarshamn",
  "Oslo",
  "Osnabrueck",
  "Oswego",
  "OSX 1",
  "OSX 3",
  "Oulu (Uleåborg)",
  "Oulu (Uleborg)",
  "Owendo",
  "Owensboro",
  "Oxelösund",
  "Oyo",
  "Paducah",
  "Pago Pago",
  "Paita",
  "Palang",
  "Palawan",
  "Paldiski Põhjasadam",
  "Palermo",
  "Palm Beach",
  "Palma de Mallorca",
  "Palmeira",
  "Palmeira CBM",
  "Panama City",
  "Pangkal Balam",
  "PANJANG LAMPUNG",
  "PANTALÁN ASFALTOS ESPAÑOLES TARRAGONA",
  "PANTALÁN DE REPSOL PETRÓLEO TARRAGONA",
  "Papeete",
  "Paradip",
  "Paradip Garh",
  "Paramaribo",
  "Paranaguá",
  "Paranagua - PR",
  "Pasacao",
  "Pascagoula",
  "Pasco Washington",
  "Pasir Gudang",
  "Pasuruan",
  "Patra",
  "Patterson, LA",
  "Paulsboro, NJ",
  "PBR Bataan Ports",
  "Pecem - CE",
  "Pemba",
  "Penang (Georgetown)",
  "Penang Port",
  "Peng Lai 19-3",
  "Pengerang LNG (Two) Sdn. Bhd.",
  "Penglai Pt",
  "Pensacola",
  "Perama",
  "Perawang",
  "Pereiras",
  "PERTAMINA Tanjung Priok",
  "PERTAMINA Tanjung Uban",
  "Peterhead",
  "PETRON BACOLOD",
  "Petron Batangas",
  "PETRON BAWING",
  "Petron Davao",
  "PETRON ILIGAN",
  "PETRON MACTAN",
  "Petron Mandaue",
  "PETRON NAVOTAS",
  "PETRON ORMOC",
  "PETRON PALAWAN",
  "PETRON ROSARIO",
  "PETRON ROXAS",
  "PETRON TAGOLOAN",
  "PETRON ZAMBOANGA",
  "PETROZUATA",
  "Philadelphia",
  "Philadelphia, Pennsylvania",
  "Philipsburg",
  "Phoenix Park Gas Processors Ltd.",
  "Pilot Station",
  "Piombino",
  "Pipavav",
  "Pipavav (Victor) Port",
  "Piraeus",
  "Pisco",
  "Pisco - Puerto General San Martin - Enapu",
  "Piteå",
  "Piti",
  "Pittsburg, CA",
  "Pittsburgh, PA",
  "Platong",
  "Ploce",
  "Plymouth",
  "Point Comfort, TX",
  "Point Fortin",
  "Point Lisas",
  "Pointe Noire DJENO",
  "Pointe-A-Pierre",
  "Pointe-à-Pitre",
  "Porbandar",
  "Pori (Björneborg)",
  "Poro",
  "Poro Point/San Fernando",
  "Poro/San Fernando",
  "Porsgrunn",
  "Port Akdeniz",
  "Port Alma",
  "Port Angeles",
  "Port Angeles WA",
  "Port Arthur",
  "Port Bienville, MS",
  "PORT BLAIR",
  "Port Bonython",
  "Port Botany",
  "Port Canaveral",
  "PORT CARTIER, QC",
  "Port de Galisbay",
  "Port Derince",
  "Port Dickson",
  "Port Elizabeth",
  "Port Esquivel",
  "Port Everglades",
  "Port Everglades, FL",
  "Port Fourchon, LA",
  "Port Gentil",
  "Port Harcourt",
  "Port Hawkesbury",
  "Port Hueneme, CA",
  "Port Ingles",
  "Port Isabel",
  "Port Kelang",
  "Port Kembla",
  "Port Khalid",
  "Port Klang (Pelabuhan Klang)",
  "Port Lincoln",
  "Port Louis",
  "Port Manatee",
  "Port Moresby",
  "Port Neches",
  "Port of Anacortes",
  "Port of Baltimore",
  "Port of Barrow Island",
  "Port of Batangas",
  "Port of Baton Rouge",
  "Port of Beaumont Texas",
  "Port of Boston",
  "Port of Cairns",
  "Port of Catoosa Oklahoma",
  "Port of Chicago",
  "Port of Corpus Christi",
  "Port of Corpus Christi, Texas",
  "Port of Ferrol",
  "Port of Fredericia",
  "PORT OF FREEPORT",
  "Port of Fujairah",
  "Port of Ghent",
  "Port of Gothenburg",
  "Port of Greater Baton Rouge",
  "Port of Harlingen, Texas",
  "Port of Houston",
  "Port of Houston Texas",
  "Port of Iloilo",
  "Port of Jacksonville Florida",
  "Port of Kaliningrad",
  "Port of Kotka",
  "Port of Libreville",
  "Port of Los Angeles / Long Beach",
  "Port of Los Angeles, Los Angeles, California",
  "Port of Mobile Alabama",
  "Port of Montreal",
  "PORT OF NEW ORLEANS",
  "Port of New York - New Jersey",
  "Port of Pasco",
  "Port of Portland Oregon",
  "Port of Pujairah",
  "Port of Rafnes",
  "Port of Richmond",
  "Port of Rotterdam",
  "PORT OF SALDANHA",
  "Port of Seattle",
  "Port of Sines",
  "Port of South Louisiana",
  "Port Of Tacoma",
  "Port of Terrebonne",
  "Port of Texas City",
  "Port of Texas City, Texas",
  "Port of Umatilla",
  "Port of Vancouver",
  "Port of Victoria",
  "Port of Vienna",
  "Port of Vysotsk",
  "Port of Wilmington",
  "Port of Yabucoa",
  "Port Prigorodnoye",
  "Port Qasim",
  "Port Reunion",
  "Port Said",
  "Port Sudan",
  "Port Sui Zhong",
  "Port Sultan",
  "Port Tupper",
  "Port Walcott, WA",
  "Port-au-Prince",
  "PORT-GENTIL",
  "Portland",
  "Portland Oregon",
  "Portland, Oregon",
  "Port-la-Nouvelle",
  "Porto Alegre",
  "Porto de Maceió",
  "Porto de Santos",
  "Porto de Suape",
  "Porto do Acu",
  "Porto Levante",
  "PORTO MARGHERA",
  "Porto Novo",
  "Porto Sal-Rei",
  "Porto Santo Island",
  "PORTO SUDESTE DO BRASIL - PORTO DE ITAGUAÍ",
  "Porto Velho",
  "Port-of-Spain",
  "Portoscuso (Porto Vesme)",
  "Portsmouth",
  "Porvoo (Borg)",
  "Pozos Colorados",
  "Praia",
  "Prelude",
  "Prigorodnoye",
  "Prince Rupert",
  "Progreso",
  "Prøvestenen",
  "Providence",
  "Providence, Rhode Island",
  "PTTOR Songkla",
  "Puerto Armuelles",
  "Puerto Bahia",
  "Puerto Barrios",
  "Puerto Bolívar",
  "Puerto Cabello",
  "Puerto Carenero",
  "Puerto Castilla",
  "Puerto Cortes",
  "Puerto Cortés",
  "PUERTO DE ALCUDIA",
  "PUERTO DE CARTAGENA",
  "PUERTO DE HUELVA",
  "Puerto de Jobos",
  "Puerto del Rosario-Fuerteventura",
  "Puerto La Cruz",
  "Puerto Mar del Plata",
  "Puerto Miranda/Maracaibo L.",
  "Puerto Moin",
  "Puerto Plata",
  "Puerto Quetzal",
  "Puerto Rosales",
  "Puerto Santo Tomás de Castilla",
  "Puerto Sara",
  "Puerto Viejo De Azua",
  "Pula",
  "Pulau Laut",
  "Punta Cardón",
  "Punta del Este",
  "Punta Europa Terminal",
  "Punta Loyola",
  "Punta Morales",
  "Purfleet",
  "PVGAS VUNGTAU TERMINAL",
  "Pyeongtaek",
  "Qalhat",
  "Qingdao",
  "Qinzhou Pt",
  "Quanzhou Pt",
  "Quebec",
  "Quiliano ( Savona ) Terminal",
  "Quintero",
  "Rabigh",
  "Rades",
  "Radès",
  "Raízen",
  "Ramallo",
  "Rang Dong",
  "Ranong",
  "Ras al Khafji",
  "Ras Laffan",
  "Ras Laffan Port",
  "Ras Lanuf",
  "Ras Tanura",
  "Ratnagiri",
  "Rauma (Raumo)",
  "Ravenna",
  "Rayong Port",
  "Regas Terminal (Sg. Udang) Sdn. Bhd.",
  "Regensburg",
  "Reni",
  "Rensselaer",
  "Reo",
  "REPSOL MOLHE SUL",
  "Réunion",
  "Reykjavík",
  "RGPPL LNG Import Terminal",
  "Rhodes",
  "Richards Bay",
  "Richmond",
  "Richmond, San Francisco CA",
  "Richmond, VA",
  "Riga",
  "Rijeka",
  "RIO CULLEN",
  "Rio de Janeiro",
  "Rio de Janeiro - RJ",
  "Rio Grande",
  "Rio Grande - RS",
  "Rio Haina",
  "Riverhead N.Y.",
  "Road Town, Tortola",
  "Rocky Point",
  "Rodbyhaven",
  "Rodeo, San Francisco Bay, California",
  "Roeselare",
  "Rønne",
  "Rosario",
  "Rosarito",
  "Roseau",
  "Rostock",
  "Rotterdam",
  "Rouen",
  "Roxas",
  "Ruby Oilfield",
  "Ryotsu",
  "Sabetta",
  "Sabine",
  "Sabine Pass",
  "SADAS GEBZE TERMINAL",
  "Sæby",
  "Saganoseki",
  "Sagunto",
  "Sai Gon",
  "Saida",
  "Saigo, Shimane",
  "Saint Croix",
  "Saint George",
  "Saint George's",
  "Saint John",
  "Saint John's",
  "Saint Louis",
  "Saint Petersburg (ex Leningrad)",
  "Saint Rose, Louisiana",
  "Sakai",
  "Sakaide",
  "Sakaiminato",
  "Sakata",
  "Salalah",
  "Salaverry",
  "Salina Cruz",
  "Salisbury",
  "Salvador",
  "Salvador - BA",
  "Salzgitter",
  "Samarinda",
  "Sampit",
  "Samsun",
  "Samut Songkram",
  "San Andres Island",
  "San Ciprian",
  "San Diego, CA",
  "San Francisco",
  "San Jose",
  "San Juan",
  "San Lorenzo",
  "San Nicolas",
  "San Nicolas (Aruba)",
  "San Pedro",
  "San Pedro de Macorís",
  "San Sebastián",
  "San Vicente",
  "Sandakan",
  "Sandakan Port",
  "Sandefjord",
  "Sandnessjøen",
  "Sandwich",
  "Sangatta",
  "Sanha LPG FPSO",
  "Santa Clara",
  "Santa Cruz de Tenerife",
  "Santa Fe",
  "Santa Marta",
  "Santa Rita",
  "Santan",
  "Santan Terminal",
  "SANTANDER",
  "Santarem",
  "Santos",
  "São Luís",
  "São Sebastião",
  "Sao Vicente",
  "Sapangar Bay Oil Teminal ( Sabah Port Sdn Bhd)",
  "Sarnia",
  "Sarroch - Porto Foxi",
  "Sasebo",
  "Sattahip",
  "Sault-Sainte-Marie",
  "Saumlaki",
  "Savannah",
  "Savannah, Georgia",
  "Savona",
  "Scapa Flow",
  "Schoten",
  "SEAOIL Irasan Port, Roxas Zamboanga Del Norte",
  "Searsport",
  "Seattle",
  "Selby dock / Rodeo 8",
  "Semarang",
  "Senari Port, Kuching",
  "Sendai",
  "Sendaishiogama",
  "Senipah Terminal",
  "Seogwipo",
  "Sepangar Bay Oil Terminal",
  "Sept-Iles",
  "SERIA CRUDE OIL TERMINAL",
  "Sete",
  "Sète",
  "Setubal",
  "Sevilla",
  "Sha Lung",
  "Shadqam",
  "Shanghai Port",
  "Shantou",
  "Sharjah",
  "Shekou Pt",
  "Shell Rio de Janeiro",
  "Shell Timur Jetty",
  "Shenzhen",
  "Shibushi",
  "Shimizu",
  "Shimonoseki",
  "SHUIDONG",
  "Sigave",
  "Sika",
  "Sillamäe",
  "Sines",
  "Singapore",
  "Sint Eustatius",
  "Siracusa",
  "Sirri Island",
  "SITRA",
  "SKA ENERGY KAZ PORT",
  "Skagen",
  "Skala Pamfilon Mytilene Lesvos (Jetty)",
  "Skelleftehamn",
  "Skhira",
  "Skikda (ex Philippeville)",
  "Skjervoy",
  "Skoghall",
  "Skoldvik",
  "Skovshoved",
  "Slavyanka",
  "Slite",
  "So Francisco do Sul",
  "Soderhamn",
  "Södertälje",
  "Sogod",
  "Sohar",
  "Song Doc",
  "Songkhla",
  "Sorong",
  "Sorreisa",
  "Sortland",
  "South Riding Point",
  "Southampton",
  "Southport, NC",
  "Sovetskaya Gavan",
  "Soyo",
  "Speyer",
  "Split",
  "Sriracha Port",
  "St Bernard Port",
  "St Paul Park Minnesota",
  "St THOMAS",
  "Stade",
  "Stanlow",
  "Stavanger",
  "Steinkjer",
  "Stenungsund",
  "Stjordal",
  "Stockholm",
  "Stockton",
  "Stockton California",
  "Stolthaven Dagenham",
  "Stornoway",
  "Stranraer",
  "Strasbourg",
  "Stura",
  "Su Tu Den",
  "Suao",
  "Suape",
  "Subic Bay",
  "Sucat Buli",
  "Sullom Voe",
  "SUMED Ain Sukhna Port",
  "SUMED Sidi Kerir Port.",
  "Sundsvall",
  "Sungai Udang Port Sdn Bhd",
  "Supe",
  "Surat Thani",
  "Surigao",
  "Suva",
  "Svendborg",
  "Svolvar",
  "Swinoujscie",
  "Sydney",
  "Szazhalombatta",
  "Szczecin",
  "Tacloban",
  "Tacoma",
  "Taganrog",
  "Tagbilaran",
  "Tahkoluoto",
  "Taicang",
  "Taichung",
  "Taipei",
  "Taixing",
  "Taizhou",
  "Takamatsu",
  "Takoradi",
  "Talara",
  "Tallinn",
  "Taman'",
  "Tampa",
  "Tampa Bay",
  "Tampa, FL",
  "Tananger",
  "Tanga",
  "Tanger Med",
  "TANGGUH LNG FIELD",
  "TANGSHAN",
  "Tanjong Kidurong Offshore",
  "Tanjung Gelang",
  "Tanjung Gelang, Kuantan",
  "Tanjung Langsat Port",
  "Tanjung Manis",
  "Tanjung Pelepas",
  "Tanjung Priok",
  "Tanjung Sekong",
  "Tanjung Uban",
  "Tantan",
  "Taomasina",
  "TARANTO",
  "Tarrafal",
  "TARRAGONA",
  "Tartus",
  "Tauranga",
  "Tawau",
  "Teesport",
  "Teesport / Seal Sands",
  "Tejn",
  "Tekirdag",
  "Teluk Bayur",
  "Tema",
  "Ten Oilfield",
  "TENES",
  "TERMAP SA - TERMINALES MARITIMAS PATAGONICAS S.A.",
  "Terminal YPF Barranqueras",
  "Terminal YPF Comodoro Rivadavia",
  "Terminal YPF Ushuaia",
  "Ternate",
  "Terneuzen",
  "Tessenderlo",
  "Tetney",
  "Texas City",
  "Thanh Hao",
  "Thessaloníki",
  "Thorshavn",
  "Thousand Island",
  "Thunder Bay",
  "TIAN JIN PORT",
  "Tianjin Port",
  "Tieshan",
  "Tobata/Kitakyushu",
  "Tobelo",
  "Tobruk",
  "Tocopilla",
  "Tokuyama",
  "Tokyo",
  "TOLEDO",
  "Toliara",
  "Tomakomai",
  "Tongyeong",
  "Tonsberg",
  "Topolobampo",
  "Toronto",
  "Toros Tarim Terminal",
  "TOTAL Bitumen Deutschland GmbH",
  "Total Gas Can Tho",
  "Toulon",
  "Townsville",
  "Toyama",
  "Trabzon",
  "Tramandaí",
  "Tramandai - RS",
  "Tranmere, Port of Liverpool",
  "Travemuende",
  "Trelleborg",
  "Trieste",
  "Trincomalee",
  "Tripoli",
  "Trois-Rivieres",
  "Tromsø",
  "Trondheim",
  "Tuapse",
  "Tuban",
  "Tubarao - ES",
  "Tumaco",
  "Turku (bo)",
  "TUTICORIN (V.O. CHIDAMBARAM PILLAI)",
  "Tuxpan",
  "TYNE",
  "Ube",
  "Udang Offshore",
  "Uddevalla",
  "Ulaanbaatar",
  "Ukpokiti Offshore",
  "Ulsan",
  "Ulsan / Onsan",
  "Um’said (Mesaieed Port)",
  "Umeå",
  "Umm Qasr",
  "Unoshima",
  "Usan Offshore Oilfield",
  "USCG Marine Safety Unit, Lake Charles",
  "USCG MSO Port Arthur",
  "Ust'-Luga",
  "Uusikaupunki (Nystad)",
  "Vadinar",
  "VADO LIGURE",
  "Vadso",
  "Vaga",
  "Valdez",
  "Vale Cavaleiros",
  "Valencia",
  "Valletta",
  "Valleyfield",
  "Valparaiso",
  "Van Gogh Terminal",
  "Van Phong",
  "Vancouver",
  "Vancouver, WA",
  "Vanino",
  "Varanus Island",
  "Varberg",
  "Varna",
  "Varoy",
  "Vasa (Vaasa)",
  "Vasilikos",
  "Vasteras",
  "Vasto",
  "Vejle",
  "Venezia",
  "Venø",
  "Ventanas",
  "Ventimiglia",
  "Ventspils",
  "Veracruz",
  "Viana do Castelo",
  "VIBO VALENTIA MARINA",
  "Vicksburg",
  "Vicosa",
  "Victoria",
  "Vieux Fort",
  "Vila do Conde",
  "Vilagarcia de Arousa",
  "Villanueva",
  "Vilvoorde",
  "Vinapu / Isla de Pascua (Eastern Island)",
  "Visakhapatnam",
  "Visby",
  "Vitoria",
  "Vitória Pt",
  "Vladivostok",
  "Vlissingen",
  "Vlorë",
  "Vohemar",
  "Vostochnyy Port",
  "Vung Tau",
  "Wadi Feiran",
  "Waingapu, Sumba",
  "Wakayama Shimotsu",
  "Walvis Bay",
  "Wandoo Offshore",
  "Wanze",
  "Warri",
  "Waterford",
  "Wayame",
  "Wei hai",
  "Weifang",
  "Weipa",
  "Weirton, West Virginia",
  "West Port, Port Kelang",
  "Westville, New Jersey",
  "Whangarei",
  "Widuri Offshore",
  "Wilhelmshaven",
  "Willemstad",
  "Wilmington",
  "Windsor",
  "Wittenberge",
  "Worms",
  "Wuerzburg",
  "Wuzhou",
  "Wyndham",
  "Xareu",
  "XIAMEN 35",
  "Xijiang Offshore",
  "Xiuyu",
  "Xiuyu Pt",
  "Yanai",
  "Yanbu al-Bahr",
  "Yangjiang",
  "Yangkou",
  "Yangon",
  "Yangpu",
  "Yangshan",
  "Yangzhou",
  "Yantai",
  "Yantian Pt",
  "Yarimca",
  "Yatsushiro",
  "Yeosu",
  "Yeysk",
  "YINGKOU",
  "Yokkaichi",
  "Yokohama",
  "Yokosuka",
  "Yorktown, VA",
  "YPF Puerto de Dock Sud",
  "YPF Puerto La Plata",
  "YPF Puerto San Lorenzo",
  "Yura",
  "Yuzhnyi",
  "Zadar",
  "Zamboanga",
  "Zanzibar",
  "Zárate",
  "Zarzis",
  "Zeebrugge",
  "Zelzate",
  "Zhangjiagang",
  "ZHANJIANG 44",
  "Zhapu",
  "Zhenjiang Pt",
  "Zhenjiang, People's Republic of China",
  "Zhongshan",
  "Zhoushan Pt",
  "Zhuhai",
  "Zhuhai Pt",
  "Zirku Island",
  "Zuara",
];
